var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "below-container" }, [
    _c("div", { staticClass: "friend-wrap" }, [
      _vm._m(0),
      _c("div", { staticClass: "friend-name-list" }, [
        !_vm.isRequestSuccess
          ? _c("div", { staticClass: "masking" })
          : _vm._e(),
        _vm.totals === 0 && !_vm.dataList.length && !_vm.loading
          ? _c("div", { staticClass: "empty-wrap" }, [_vm._v(" 暂无数据 ")])
          : _vm._e()
      ])
    ]),
    _c(
      "div",
      { staticStyle: { flex: "6" } },
      [
        _c("ChatType", {
          attrs: { idData: _vm.idSet, chatType: "employees" },
          on: { requestSuccess: _vm.requestSuccess }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "friend-category" }, [
      _c("div", { staticClass: "card" }, [_c("div", [_vm._v("外部好友")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }